<template>
  <div class="east-search-item-group">
    <div class="central__group-item" :title="group.title">
      <span>
        <span class="span-ellipsis">{{ group.title }}</span>
      </span>
    </div>
    <div class="central__item" v-for="item in group.items" @click="handleItemClick(item.ProgramType.code, item.id)">
      <div class="central__item__icon">
        <nuttrema-iconica-kcal
           className="iconica--small"
          :title="$t('label.average_daily_energy_value')"
          :text="item.name"
          :image="getImagePath(item)"
          :nutrientDefinition="_get(item, 'summary.nutrition', {})">
        </nuttrema-iconica-kcal>
    </div>
      <div class="central__item__text" :title="item.name">
        <div class="central__item__title">
          <span>
            <span class="span-ellipsis">{{ item.name }}</span>
          </span>
        </div>
        <div class="central__item__description">
          <span>
            <span class="span-ellipsis">
              {{ $tc('label.days_number', item.duration, { duration: item.duration }) }}
            </span>
          </span>
        </div>
      </div>
      <div v-if="_get(item, 'Allergens')" class="central__item__info">
        <nuttrema-allergens-info :allergens="_get(item, 'Allergens')" trigger="hover"></nuttrema-allergens-info>
      </div>
      <div class="central__item__action">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import EastSearchItemGroup from 'components/ui/search/east-search-item-group';

import { isNil } from 'lodash';
import { PROGRAMS_KEYS } from 'constants/types';

export default {
  name: 'cmpt-east-search-programs-item-group',
  mixins: [EastSearchItemGroup],
  methods: {
    handleItemClick(code, programID) {
      this.$emit('itemClick', {
        programID,
        programType: PROGRAMS_KEYS[code],
      });
    },
    getImagePath(item) {
      return !isNil(item.CoverImage) ? `${process.env.IMAGES_ROOT}${item.CoverImage.path}${item.CoverImage.thumbnails.large.filename}` : '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/search-east/cmpt-east-search-programs-item-group.vue